
























































import { Vue, Prop, Model, Component } from 'vue-property-decorator'
import { Operador } from '@/models/venda/Operador'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { MetaDiaria } from '@/models/MetaDiaria'
import { FindMetaDiariaUseCase } from '@/usecases/metaDiaria/FindMetaDiariaUseCase';
import { SaveMetaDiariaUseCase } from '@/usecases/metaDiaria/SaveMetaDiariaUseCase';
import type { Meta } from '@/models';
import { formatarMoeda } from '@/shareds/formatadores';

@Component
export default class DialogoMetaDiaria extends Vue {
	@Model('input', { type: Boolean }) readonly value!: boolean
	@Prop({ type: Object, default: null }) vendedorSelecionado!: Operador | null
	@Prop({ type: Object, default: null }) meta!: Meta
	saveUseCase = new SaveMetaDiariaUseCase()
	findUseCase = new FindMetaDiariaUseCase()

	formatarMoeda = formatarMoeda

	dialogKey = 0
	metaDiaria: MetaDiaria | null = null
	carregando = false
	erro: any | Error = null
	valorMeta: number | null = null
	percentualMeta: number | null = null

	mostrarDialogoDiaSelecionado = false
	diaSelecionado: string | null = null
	$refs!: {
		calendar: any
	}
	dataAtual: string = new Date().toISOString().substr(0, 10) // YYYY-MM-DD
	eventos: any = []

	money = {
		decimal: ',',
		thousands: '.',
		prefix: 'R$ ',
		precision: 2,
		masked: false,
	}

	get mostrar() {
		return this.value
	}
	set mostrar(val: boolean) {
		this.$emit('input', val)
	}

	async fechar() {
		const valorTotalMetasDiarias = await this.findUseCase
			.getValorTotalMetasDiarias(this.meta.id, this.$refs.calendar.lastStart.date, this.$refs.calendar.lastEnd.date);

		if (this.meta.valor != valorTotalMetasDiarias) {
			AlertModule.setWarning(
				`A meta do mês com valor diferente do total das metas diárias: ${this.money.prefix}${valorTotalMetasDiarias.toFixed(2)}`,
			)
		}

		this.mostrar = false
		this.dialogKey++
		this.dataAtual = ""
	}

	onSelecionarDiaEvento({ event }: { event: any }) {
		this.valorMeta = 0
		this.percentualMeta = 0
		this.metaDiaria = null
		if (event.metaDiaria) {
			this.metaDiaria = event.metaDiaria
			this.valorMeta = event.metaDiaria.valor
			this.percentualMeta = event.metaDiaria.percentual

		}
		this.diaSelecionado = event.start
		this.mostrarDialogoDiaSelecionado = true
	}

	async atualizaCalendario(start: any, end: any) {
		if (!this.vendedorSelecionado) {
			this.eventos = []
			return
		}
		try {
			this.carregando = true
			const metasDiarias = await this.findUseCase.findByUserAndRange(
				this.meta.id,
				this.vendedorSelecionado.id,
				start.date,
				end.date,
			)
			const datas: string[] = []
			const dataAtual = new Date(start.date)
			const dataFim = new Date(end.date)
			while (dataAtual <= dataFim) {
				datas.push(dataAtual.toISOString().slice(0, 10))
				dataAtual.setDate(dataAtual.getDate() + 1)
			}
			this.eventos = datas.map(data => {
				const meta = metasDiarias.find(m => m.data.slice(0, 10) === data)
				if (meta) {
					return {
						name: `R$ ${formatarMoeda(meta.valor)}`,
						start: meta.data.slice(0, 10),
						color: 'purple',
						timed: false,
						metaDiaria: meta,
					}
				} else {
					return {
						name: 'Sem meta',
						start: data,
						color: 'grey',
						timed: false,
						metaDiaria: null,
					}
				}
			})
		} catch (e) {
			this.eventos = []
			this.erro = e
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	prev() {
		if (this.$refs.calendar) {
			this.$refs.calendar.prev()
		}
	}
	next() {
		if (this.$refs.calendar) {
			this.$refs.calendar.next()
		}
	}

	async updateRange({ start, end }: { start: any; end: any }) {
		await this.atualizaCalendario(start, end)
	}

	async salvarMetaDiaria() {
		if (!this.vendedorSelecionado || !this.diaSelecionado) {
			AlertModule.setError('Selecione um vendedor e um dia.')
			return
		}
		if (this.valorMeta === null || this.percentualMeta === null) {
			AlertModule.setError('Preencha os campos de valor e percentual.')
			return
		}

		const metaDiaria: MetaDiaria = {
			...this.metaDiaria,
			data: this.diaSelecionado,
			valor: this.valorMeta,
			percentual: this.percentualMeta,
			vendedor: this.vendedorSelecionado,
			meta: this.meta,
		}
		const upodatedMetaDiaria = await this.saveUseCase.update(metaDiaria)
		metaDiaria.id = upodatedMetaDiaria.id
		const idx = this.eventos.findIndex(
			(ev: any) => ev.start === this.diaSelecionado,
		)
		if (idx !== -1) {
			this.eventos[idx] = {
				...this.eventos[idx],
				name: `R$ ${formatarMoeda(this.valorMeta)}`,
				metaDiaria: metaDiaria,
				color: 'purple',
			}
		}
		this.eventos = [...this.eventos]
		this.mostrarDialogoDiaSelecionado = false
	}
}
